'use client';

import { getConfig, is3rdPartyDisabled } from '@fshr/shared-react';
import Script from 'next/script';

export default function OneTrustScript() {
	const { FSHR_PUBLIC_ONE_TRUST_TAG } = getConfig();
	const oneTrustDisabled = is3rdPartyDisabled('one-trust');
	return oneTrustDisabled ? (
		<></>
	) : (
		<Script
			type="text/javascript"
			src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
			strategy="afterInteractive"
			charSet="UTF-8"
			data-document-language={true}
			data-domain-script={FSHR_PUBLIC_ONE_TRUST_TAG}
		/>
	);
}
